/**
 * @ngdoc service
 * @name messages.factory:Message
 *
 * @description
 *
 */
angular
    .module('festzelt-os.modules.messages')
    .factory('SmsTemplate', [
        'locale',
        'Resource',
        SmsTemplate
    ]);

function SmsTemplate(locale, Resource) {
    return Resource.make('messages/sms/templates');
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/factories/sms-template-factory.js